import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../utils/withRouter";

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_id: sessionStorage.getItem("user_id"),
            role_id: sessionStorage.getItem("role_id"),
            headerNames: [],
            headerData: [],
            selectedEvent: null,
            guest: sessionStorage.getItem("AwardsUserLoginData") == null,
            redirect: false,
            activeTab: '',
        };
    }
    render() {
        return (
            <>
                <footer id="sticky-footer" class="flex-shrink-0 py-2 bg-dark text-white-50">
                    <div class="container text-center">
                        <small>Copyright &copy; ITME Technical Awards</small>
                    </div>
                </footer>
            </>
        )
    }
}

export default withRouter(
    connect(null, {})(Footer)
);
